<template>
    <div class="col groupList">
        <strong>{{group}}</strong><br>
        <div class="row">
            <div class="col teamName colTitle">Selección</div>
            <div class="col position colTitle"> Pos. <strong> 1º &nbsp;2º</strong></div>
         </div>
         <div class="row listTeam" v-for="team in groupList" :key="team.id">
            <div class="col teamName"> 
                <div class="flag">
                <img :src="require(`@/assets/flags/${team.flag}.svg`)">
            </div>
                {{team.name}}
                </div>
                <div class="col position">
                <input class="form-check-input me-1" type="radio" v-bind:value="team.name" v-bind:name="team.id" v-model="place1" @click="this.$emit('pos1', team.id)">
                <input class="form-check-input me-1" type="radio" v-bind:value="team.name" v-bind:name="team.id" v-model="place2" @click="this.$emit('pos2', team.id)">
            </div>
         </div>  
    </div>
</template>

<script>
export default {
    name: "TeamsList",
    props: {
        group: String,
        groupList: {type: Array},
    },
    data() {
    return {
        place1: "",
        place2: ""
        };
    }
   
}
</script>

<style scope>
.groupList {margin:10px; background-color: #ffffff2e; padding: 10px 10px 0px !important; border-radius: 10px;}
.form-check-input {cursor: pointer; border: 2px solid #ddd !important; background-color: transparent !important; padding: 8px;}
.form-check-input:hover {border: 2px dotted #FC0 !important;}
.form-check-input:checked {background-color: #FC0 !important; border-color: #FC0 !important; background-image: none !important;}
.position {text-align: right; max-width: 85px !important;}
.listTeam { background-color: #00000080; padding: 7px 0px !important; }
.row.listTeam:hover { background-color: #ffffff0f;}
.teamName {text-align: left; font-size: 13px; align-items: center; display: flex;}
.colTitle {font-size: 12px; margin: 0px;}
.flag {width: 26px; display: inline-block; border-radius: 50%; height: 26px; overflow: hidden; margin-right: 5px;}
.flag img{width: 40px; margin-left: -7px;}
</style>